import { sum } from 'lodash';

export default {
  methods: {
    getRatio(num, total) {
      if (total === 0) {
        return 0;
      }

      return (num / total) * 100;
    },

    getSum(numList) {
      return sum(numList);
    },

    getToCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

  },
};



// WEBPACK FOOTER //
// ./src/mixins/numbers.js